import Vue from "vue";
import Vuex from "vuex";
import site from "./modules/site";
import advices from "./modules/advices";
import news from "./modules/news";
import page from "./modules/page";
import pin from "./modules/pin";
import createLogger from "@/plugins/logger";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    advices,
    news,
		page,
		pin,
		site
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});
